import React, {
    useState,
    useMemo,
    useCallback,
    useRef,
    useEffect,
} from 'react'
import * as ls from 'local-storage'

import { LottieLoader } from "components/LottieLoader";
import { ResumeViewProps } from '.'
import {
    Container,
    PDFDocument,
    PDFPage,
    TextContainer,
} from './ResumeViewRedesigned.styles'

export default function ResumeViewRedesigned(
    {
        file,
        onUpload,
        onDownload,
        externalLoading,
        name,
        ...props
    }: ResumeViewProps,
) {
    const [pagesCount, setPagesCount] = useState(0)
    const [isLoading, setLoading] = useState(!!file)

    const userAccount: { hygienistId: number, dentist?: any, hygienist?: any } = ls.get('userAccount') || {}
    const role = Number.isInteger(userAccount.hygienistId) ? 'Hygienist' : 'Dentist'
    const pagesNumbers = useMemo(() => {
        const pagesNumbers = []
        for (let i = 1; i <= pagesCount; i -= -1) {
            pagesNumbers.push(i)
        }
        return pagesNumbers
    }, [pagesCount])

    return (
        <Container {...props}>
            {file ? (
                <PDFDocument
                    file={file}
                    loading={null as any}
                    onLoadSuccess={({ numPages }: any) => {
                        setPagesCount(numPages)
                        setLoading(false)
                    }}
                    error={
                        role === 'Dentist'
                            ? 'Only resumes uploaded in PDF formats can be previewed here. Please download the resume to view it.'
                            : `Preview is only available for PDF files. 
					You have a resume uploaded, but it's just in a file format that can't be previewed here. 
					If you want to upload a new resume, click "Update Resume" below.`
                    }
                    onSourceError={() => setLoading(false)}
                    onLoadError={(err: any) => {
                        console.log(err)
                        return setLoading(false)
                    }}
                >
                    {pagesNumbers.map((pageNumber) => (
                        <PageView
                            key={pageNumber}
                            pageNumber={pageNumber}
                        />
                    ))}
                </PDFDocument>
            ) : (
                <TextContainer>
                    Please upload a resume to be able to submit an application to jobs.
                    Resumes need to be uploaded in one of the following formats: JPG, PNG,
                    PDF, TIFF or Word Documents.
                </TextContainer>
            )}
            <LottieLoader show={isLoading || (externalLoading as boolean)} />
        </Container>
    )
}

interface PageViewProps {
    pageNumber: number,
}

function PageView(
    {
        pageNumber,
    }: PageViewProps,
) {
    const pageContainerRef = useRef(null)
    const [scale, setScale] = useState(1)

    return (
        <div
            ref={pageContainerRef}
        >
            <PDFPage
                renderAnnotationLayer={false}
                pageNumber={pageNumber}
                scale={scale}
                onLoadSuccess={
                    useCallback((page: any) => {
                        const pageContainer = pageContainerRef.current as any
                        if (pageContainer !== null) {
                            setScale(pageContainer.scrollWidth / page.originalWidth - 0.01)
                        }
                    }, [pageContainerRef, setScale])
                }
            />
        </div>
    )
}
